import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import Message from '../../../components/message';
import { MessageSections } from '../../../components/message/message';
import { onPayNow } from "../../order-popup/payment-details/payment-functions";
import { OrderModel } from '../../../shared/models/order/order-item.model';

import { useAppDispatch, useAppSelector } from '../../../../redux/store';

export default function PayConfirmDialog({ open, setOpen, setPaymentPopupOpened, order }: {
    open: boolean,
    setOpen: (arg: boolean) => void,
    setPaymentPopupOpened?: (isSucceeded: boolean) => void,
    order: OrderModel,
}) {

    const { balance } = useAppSelector(state => state.balanceReducer);
    const amdBalanceModel = balance.find(balanceModel => balanceModel.currency.currencyId === 2);
    const amdAmount = amdBalanceModel ? amdBalanceModel.amount : 0;
    const { messageCache, languageId } = useAppSelector(state => state.messagesReducer);

    const shouldPay =
        amdAmount && order?.paymentInfo?.shippingAmount
            ? order.paymentInfo.shippingAmount > amdAmount
                ? order.paymentInfo.shippingAmount - amdAmount - (order?.paymentInfo?.appliedDiscount || 0)
                : undefined
            : order?.paymentInfo?.shippingAmount ? order.paymentInfo.shippingAmount - (order?.paymentInfo?.appliedDiscount || 0) : undefined

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = () => {
        setOpen(false);
        onPayNow(order, navigate, dispatch, messageCache, languageId, setPaymentPopupOpened, shouldPay);
    };

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Message messageKey={'order_list_sure_to_pay'} sectionId={MessageSections.ORDERS} />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        <Message messageKey={'cancel'} sectionId={MessageSections.ORDERS} />
                    </Button>
                    <Button onClick={handleClick} autoFocus>
                        <Message messageKey={'order_list_pay'} sectionId={MessageSections.ORDERS} />
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}
